import React, { useEffect, useState } from 'react';
import { Api } from '../../logic/Api/Api';
import { IJdConnectFarmFieldOrgResponse } from '../../logic/Map/JdConnectFieldMap/JdConnectFieldMap';
import _ from 'lodash';
import { generateRandomColor } from '../../logic/Utility/Utils';

/**
 * Fetch an invitation's details from the server
 */
export function useGetJdConnectFields(
	invitationCode: string, 
	api: Api, 
	setMessage: (message:React.ReactNode) => unknown,
	startLoading: () => void, 
	endLoading: () => void) 
{
	const [treeResponse, setTreeResponse] = useState<IJdConnectFarmFieldOrgResponse[]>();
	useEffect(() => 
	{
		startLoading();
		async function exec() 
		{
			try 
			{
				const response = await api.getUnauthorizedAsync<IJdConnectFarmFieldOrgResponse[]>(`6/jd-connect/invitations/${invitationCode}/fields`);
				if (response.Success) 
				{
					let responseData = _.cloneDeep(response.Data);
					responseData = responseData.map(org =>
					{
						org.FarmList = org.FarmList.map((farm,index) =>
						{
							const farmColor = generateRandomColor(org.FarmList.length, index);
							farm.Color = farmColor;

							farm.Fields = farm.Fields.map(field =>
							{
								field.FarmId = farm.Id;
								field.Color = farmColor;
								return field;
							});

							farm.OrgId = org.Id;
							return farm;
						});
						return org;
					});
					setTreeResponse(responseData);
				}
				else 
				{
					setMessage(<div>There was a problem getting the list of John Deere Fields. Contact your <a href="https://agconnections.zendesk.com/hc/en-us/categories/1500001012341-E-Luminate">support specialist</a>.</div>);
				}
			}
			catch (err) 
			{
				setMessage(<>An unknown error occurred. Please try again later.</>);
			}
			finally 
			{
				endLoading();
			}
		}
		exec();
	}, [invitationCode, api, setMessage, startLoading, endLoading]);

	return treeResponse;
}
